/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseEntryPermission } from './DatabaseEntryPermission';
import {
    DatabaseEntryPermissionFromJSON,
    DatabaseEntryPermissionFromJSONTyped,
    DatabaseEntryPermissionToJSON,
} from './DatabaseEntryPermission';

/**
 * all permissions for a database
 * @export
 * @interface DatabasePermissionMatrix
 */
export interface DatabasePermissionMatrix {
    /**
     * 
     * @type {DatabaseEntryPermission}
     * @memberof DatabasePermissionMatrix
     */
    platform?: DatabaseEntryPermission;
    /**
     * 
     * @type {DatabaseEntryPermission}
     * @memberof DatabasePermissionMatrix
     */
    registered?: DatabaseEntryPermission;
    /**
     * 
     * @type {DatabaseEntryPermission}
     * @memberof DatabasePermissionMatrix
     */
    anonymous?: DatabaseEntryPermission;
    /**
     * 
     * @type {boolean}
     * @memberof DatabasePermissionMatrix
     */
    anonymousAccessRequiresPassword?: boolean;
}

/**
 * Check if a given object implements the DatabasePermissionMatrix interface.
 */
export function instanceOfDatabasePermissionMatrix(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePermissionMatrixFromJSON(json: any): DatabasePermissionMatrix {
    return DatabasePermissionMatrixFromJSONTyped(json, false);
}

export function DatabasePermissionMatrixFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePermissionMatrix {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'platform': !exists(json, 'platform') ? undefined : DatabaseEntryPermissionFromJSON(json['platform']),
        'registered': !exists(json, 'registered') ? undefined : DatabaseEntryPermissionFromJSON(json['registered']),
        'anonymous': !exists(json, 'anonymous') ? undefined : DatabaseEntryPermissionFromJSON(json['anonymous']),
        'anonymousAccessRequiresPassword': !exists(json, 'anonymousAccessRequiresPassword') ? undefined : json['anonymousAccessRequiresPassword'],
    };
}

export function DatabasePermissionMatrixToJSON(value?: DatabasePermissionMatrix | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'platform': DatabaseEntryPermissionToJSON(value.platform),
        'registered': DatabaseEntryPermissionToJSON(value.registered),
        'anonymous': DatabaseEntryPermissionToJSON(value.anonymous),
        'anonymousAccessRequiresPassword': value.anonymousAccessRequiresPassword,
    };
}

